import { Button } from 'uikit';
import { getCheckedIdsArr } from 'utils';

import { useCallback, useMemo, useState } from 'react';

import { AgreementsAddTable } from '../AgreementsAddTable';
import { useAddMtrAgreements } from '../hooks/useAddMtrAgreements';
import { useAgreementTableAddMtr } from '../hooks/useAgreementTableAddMtr';

interface IAgreementsAddMtrProps {
    refreshAgreementMtr: () => void;
    refreshFilters: () => void;
    disabledByStatus: boolean;
    isDisabledByProjectStatus: boolean;
    isDisabledByContractStatus: boolean;
}

export const AgreementsAddMtr = ({
    refreshAgreementMtr,
    disabledByStatus,
    isDisabledByProjectStatus,
    isDisabledByContractStatus,
    refreshFilters,
}: IAgreementsAddMtrProps) => {
    const [openModal, setOpenModal] = useState<boolean>(false);

    const handleOpenModal = useCallback(() => setOpenModal(true), []);
    const handleCloseModal = useCallback(() => setOpenModal(false), []);

    const {
        titleModal,
        searchPlaceholder,
        agreementId,
        checkedIds,
        setCheckedIds,
        searchString,
        agreementsData,
        agreementsStatus,
        agreementsErrors,
        finalColumns,
        isSubmittedDataTable,
        handleCloseErrorAgreementTable,
        handleSearch,
        handleChange,
        handleClearSearch,
    } = useAgreementTableAddMtr(openModal);

    const {
        titleAddError,
        addMtrAgreementsData,
        addMtrAgreementsStatus,
        addMtrAgreementsError,
        isSubmittedAddMtr,
        handleAddMtrAgreements,
        handleCloseErrorModalAddMtr,
        handleCreateReportAddMtr,
    } = useAddMtrAgreements(agreementId, checkedIds, setCheckedIds, refreshAgreementMtr, setOpenModal, refreshFilters);

    const isConfirmDisabled = useMemo(() => !getCheckedIdsArr(checkedIds).length, [checkedIds]);

    return (
        <>
            <Button
                label="Добавить МТР"
                size="s"
                view="secondary"
                onClick={handleOpenModal}
                disabled={disabledByStatus || isDisabledByProjectStatus || isDisabledByContractStatus}
            />
            {openModal && (
                <AgreementsAddTable
                    titleModal={titleModal}
                    handleCloseAddAgreements={handleCloseModal}
                    handleAddAgreements={handleAddMtrAgreements}
                    searchPlaceholder={searchPlaceholder}
                    searchString={searchString}
                    handleChange={handleChange}
                    handleSearch={handleSearch}
                    handleClearSearch={handleClearSearch}
                    tableColumns={finalColumns}
                    isSubmittedAddMtr={isSubmittedAddMtr}
                    addAgreementsStatus={addMtrAgreementsStatus}
                    addAgreementsData={addMtrAgreementsData}
                    addAgreementsError={addMtrAgreementsError}
                    handleCloseErrorModalAdd={handleCloseErrorModalAddMtr}
                    handleCreateReportAdd={handleCreateReportAddMtr}
                    titleAddError={titleAddError}
                    isSubmittedDataTable={isSubmittedDataTable}
                    agreementsStatus={agreementsStatus}
                    agreementsData={agreementsData}
                    agreementsErrors={agreementsErrors}
                    handleCloseErrorAgreementTable={handleCloseErrorAgreementTable}
                    isConfirmDisabled={isConfirmDisabled}
                />
            )}
        </>
    );
};

AgreementsAddMtr.displayName = 'AgreementsAddMtr';
